// extracted by mini-css-extract-plugin
export var actionText = "_nm-4";
export var container = "_nm-0";
export var leftSection = "_nm-1";
export var rightSection = "_nm-2";
export var settingsButton = "_nm-6";
export var settingsIcon = "_nm-7";
export var shortcut = "_nm-5";
export var shortcutGroup = "_nm-3";